export default "__VITE_ASSET__BqzP3oQP__"